<section class="admin-account-security">
  <header class="admin-account-security__header">
    <h1>{{ 'ADMIN.ACCOUNT_SECURITY.TITLE' | translate }}</h1>
    <p>{{ 'ADMIN.ACCOUNT_SECURITY.DESCRIPTION' | translate }}</p>
  </header>

  <nz-card [nzTitle]="'ADMIN.ACCOUNT_SECURITY.PASSWORD_TITLE' | translate">
    <p class="section-description">{{ 'ADMIN.ACCOUNT_SECURITY.PASSWORD_DESCRIPTION' | translate }}</p>
    <app-change-password></app-change-password>
  </nz-card>

  <nz-card [nzTitle]="'ADMIN.ACCOUNT_SECURITY.MFA_TITLE' | translate" class="mfa-card">
    <p class="section-description">{{ 'ADMIN.ACCOUNT_SECURITY.MFA_DESCRIPTION' | translate }}</p>

    <nz-spin *ngIf="isMfaStatusLoading"></nz-spin>

    <p *ngIf="mfaStatusLoadFailed" class="status-error">
      {{ 'ADMIN.ACCOUNT_SECURITY.STATUS_LOAD_FAILED' | translate }}
    </p>

    <ng-container *ngIf="!isMfaStatusLoading && !mfaStatusLoadFailed">
      <p *ngIf="canReplaceAuthenticator" class="mfa-status mfa-status--enabled">
        {{ 'ADMIN.ACCOUNT_SECURITY.AUTHENTICATOR_ENABLED' | translate }}
      </p>

      <p *ngIf="!canReplaceAuthenticator" class="status-error">
        {{ 'ADMIN.ACCOUNT_SECURITY.STATUS_UNAVAILABLE' | translate }}
      </p>

      <form
        *ngIf="canReplaceAuthenticator"
        [formGroup]="replacementForm"
        (ngSubmit)="startReplacement()"
        class="mfa-replacement-form"
      >
        <h2>{{ 'ADMIN.ACCOUNT_SECURITY.REPLACE_TITLE' | translate }}</h2>
        <p>{{ 'ADMIN.ACCOUNT_SECURITY.REPLACE_DESCRIPTION' | translate }}</p>

        <nz-form-item>
          <nz-form-label nzFor="currentAuthenticatorCode">
            {{ 'ADMIN.ACCOUNT_SECURITY.CURRENT_AUTHENTICATOR_CODE' | translate }}
          </nz-form-label>
          <nz-form-control>
            <input
              nz-input
              id="currentAuthenticatorCode"
              type="text"
              inputmode="numeric"
              autocomplete="one-time-code"
              formControlName="code"
              [class.input-invalid]="replacementForm.get('code')?.invalid && replacementForm.get('code')?.touched"
              [attr.aria-invalid]="replacementForm.get('code')?.invalid && replacementForm.get('code')?.touched ? 'true' : null"
            />
            <div *ngIf="replacementForm.get('code')?.invalid && replacementForm.get('code')?.touched" class="error-text">
              {{ 'ADMIN.ACCOUNT_SECURITY.INVALID_CODE' | translate }}
            </div>
          </nz-form-control>
        </nz-form-item>

        <button nz-button nzType="primary" type="submit" [nzLoading]="isStartingReplacement">
          {{ 'ADMIN.ACCOUNT_SECURITY.START_REPLACEMENT' | translate }}
        </button>
      </form>
    </ng-container>
  </nz-card>
</section>
